<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button
        type="primary"
        icon="ios-add"
        @click="createSalesman()"
        v-if="isHavePermission('baseUserSales:createSales')"
        >新增业务员</Button
      >
      <Button
        type="primary"
        style="margin-left:10px"
        icon="md-refresh"
        v-if="isHavePermission('baseUserSales:changeClientManager')"
        @click="changeClientManager()"
        >更换客户经理</Button
      >
      <Button
        type="primary"
        style="margin-left:10px"
        v-if="isHavePermission('baseUserSales:clientManagerReplace')"
        @click="clientManagerReplace()"
        >客户经理变更</Button
      >
      <vxe-button
          icon="vxe-icon--download"
          style="margin-left:10px"
          @click="exportData"
          v-if="isHavePermission('baseUserSales:export')"
      >导出
      </vxe-button>
      <Button icon="md-refresh" @click="getList" style="margin-left: 10px"
        >刷新</Button
      >
      <div class="authorization-header">
        <span>
          <label>客户经理:</label>
          <vxe-input
            v-model="listQuery.clientManager"
            @keyup.enter.native="search"
            placeholder="请输入客户经理"
            style="width: 120px;"
          ></vxe-input>
        </span>
        <span>
          <label>销售经理:</label>
          <vxe-input
            v-model="listQuery.salesManager"
            @keyup.enter.native="search"
            placeholder="请输入销售经理"
            style="width: 120px;"
          ></vxe-input>
        </span>
        <span>
          <label>外部销售:</label>
          <vxe-input
              v-model="listQuery.salesManagerOutside"
              @keyup.enter.native="search"
              placeholder="请输入外部销售"
              style="width: 120px;"
          ></vxe-input>
        </span>
        <span>
          <label>业务员:</label>
          <vxe-input
            v-model="listQuery.salesMan"
            @keyup.enter.native="search"
            placeholder="请输入业务员"
            style="width: 120px;"
          ></vxe-input>
        </span>
        <span>
          <label>签约:</label>
          <vxe-select v-model="listQuery.isSign" placeholder="请选择" clearable style="width: 120px;">
            <vxe-option value="1" label="是"></vxe-option>
            <vxe-option value="0" label="否"></vxe-option>
          </vxe-select>
        </span>
        <span>
          <label>提成:</label>
          <vxe-select v-model="listQuery.isCps" placeholder="请选择" clearable style="width: 120px;">
            <vxe-option value="1" label="是"></vxe-option>
            <vxe-option value="0" label="否"></vxe-option>
          </vxe-select>
        </span>
        <Button status="primary" icon="ios-search" @click="search">搜索</Button>
      </div>
    </div>
    <div class="list-box common-shadow clearfix" style="margin-top: 10px;">
      <vxe-table
        class="table-style"
        stripe
        highlight-hover-row
        max-height="540"
        border="none"
        align="center"
        :loading="loading"
        :data="salesmanData"
        @checkbox-all="selectAllEvent"
        @checkbox-change="selectChangeEvent"
      >
        <vxe-table-column
          type="checkbox"
          align="center"
          width="50"
        ></vxe-table-column>
        <vxe-table-column field="id" title="操作" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown
              trigger="click"
              style="margin-left: 20px;"
              transfer
              v-if="
                isHavePermission('baseUserSales:querySalesDetail') ||
                  isHavePermission('baseUserSales:updateSales') ||
                  isHavePermission('baseUserSales:removeSales')
              "
            >
              <icon
                type="text"
                custom="iconfont icon-gengduo"
                size="12px"
              ></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <!-- <Button class="button-gengduo" @click="seeSalesman(row)" v-if="isHavePermission('baseUserSales:querySalesDetail')">查看</Button> -->
                  <Button
                    class="button-gengduo"
                    @click="editSalesman(row)"
                    v-if="isHavePermission('baseUserSales:updateSales')"
                    >编辑</Button
                  >
                  <Button
                    class="button-gengduo"
                    style="color: #ed4014;"
                    @click="delSalesman(row)"
                    v-if="isHavePermission('baseUserSales:removeSales')"
                    >删除</Button
                  >
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="salesMan" title="业务员" show-overflow>
          <template slot-scope="{ row }">
            <span
              @click="seeSalesman(row)"
              style="cursor:pointer;color: #2d8cf0;"
              >{{ row.salesMan }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="clientManager" title="客户经理">
          <template slot-scope="{ row }">
            <span>{{ row.clientManager }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="salesManager"
          title="销售经理"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="salesManagerOutside"
            title="外部销售经理"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column field="isSign" title="签约">
          <template slot-scope="{ row }">
            <span>{{ row.isSign | isSignRule }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isCps" title="提成">
          <template slot-scope="{ row }">
            <span>{{ row.isCps | isSignRule }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rateCps" title="内部提成">
          <template slot-scope="{ row }">
            <span v-if="row.rateCps">{{ row.rateCps }} %</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rateCpsOutside" title="外部提成">
          <template slot-scope="{ row }">
            <span v-if="row.rateCpsOutside">{{ row.rateCpsOutside }} %</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createUser"
          title="创建人"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="totalResult"
        @page-change="handleCurrentChange"
      ></vxe-pager>
    </div>
    <create-salesman-modal
      ref="createSalesman"
      @createCommit="createCommit"
    ></create-salesman-modal>
    <salesman-detail ref="salesmanDetail"></salesman-detail>
    <vxe-modal
      v-model="changeClientManagerModal"
      :title="changeClientManagerTitle"
      width="400"
      height="200"
    >
      <div style="padding-top:10px">
        <vxe-form
          :data="clientManagerFormData"
          @submit="changeClientManagerCommit"
        >
          <vxe-form-item
            title="替换的客户经理:"
            field="clientManagerId"
            style="padding-right: 10px"
            span="24"
            title-align="left"
          >
            <Select v-model="clientManagerFormData.clientManagerId" filterable transfer>
              <Option
                v-for="item in salesManageList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}
              </Option>
            </Select>
          </vxe-form-item>
          <div style="float: right">
            <vxe-form-item>
              <vxe-button
                type="submit"
                status="primary"
                style=" border-radius: 0px;"
                >确认
              </vxe-button>
            </vxe-form-item>
          </div>
        </vxe-form>
      </div>
    </vxe-modal>
    <vxe-modal
      v-model="clientManagerReplaceModal"
      :title="clientManagerReplaceTitle"
      width="400"
      height="250"
    >
      <div style="padding-top:10px">
        <vxe-form
          :data="clientManagerReplaceFormData"
          @submit="clientManagerReplaceCommit"
        >
          <vxe-form-item
            title="原客户经理:"
            field="oldId"
            style="padding-right: 10px"
            :title-width="120"
            span="24"
            title-align="left"
          >
            <Select v-model="clientManagerReplaceFormData.oldId" filterable transfer>
              <Option
                v-for="item in salesManageList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}
              </Option>
            </Select>
          </vxe-form-item>
          <vxe-form-item
            title="替换的客户经理:"
            field="newId"
            style="padding-right: 10px"
            :title-width="120"
            span="24"
            title-align="left"
          >
            <Select v-model="clientManagerReplaceFormData.newId" filterable transfer>
              <Option
                v-for="item in salesManageList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}
              </Option>
            </Select>
          </vxe-form-item>
          <div style="float: right">
            <vxe-form-item>
              <vxe-button
                type="submit"
                status="primary"
                style=" border-radius: 0px;"
                >确认
              </vxe-button>
            </vxe-form-item>
          </div>
        </vxe-form>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import CreateSalesmanModal from "@/views/authorization/CreateSalesmanModal";
import SalesmanDetail from "@/views/authorization/SalesmanDetail";
import { timeFormatDate, timeToVal } from "@/filters/time";
import getAuthOrization from "@/mixin/getAuthOrization";
import {getBlob, hideLoading, isEmpty, saveBlob, showLoading} from "@/utils/util";

export default {
  components: {
    CreateSalesmanModal,
    SalesmanDetail
  },
  mixins: [getAuthOrization],

  data() {
    return {
      salesmanData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
      listQuery: {
        page: 1,
        rows: 10
        // orderBy:2,
        // isDesc:1
      },
      //新增
      createSalesmanModal: false,
      salesmanList: [],
      clientManager: null,
      salesManager: null,
      salesMan: null,
      changeClientManagerModal: false,
      changeClientManagerTitle: "更换客户经理",
      salesManageList: [],
      clientManagerFormData: {
        clientManagerId: null
      },
      records: [],
      clientManagerReplaceModal: false,
      clientManagerReplaceTitle: "客户经理变更",
      clientManagerReplaceFormData: {
        oldId: null,
        newId: null
      }
    };
  },
  mounted() {
    this.$bus.$on("角色管理", () => {
      this.getList();
    });
    this.getList();
  },
  filters: {
    isSignRule(p) {
      if (p == 1) {
        return "是";
      } else if (p == 0) {
        return "否";
      }
    }
  },
  methods: {
    async exportData() {
      if (isEmpty(this.salesmanData)) {
        this.$XModal.message("先搜索数据");
        return;
      }
      showLoading();
      let res = getBlob(
          "/api/auth/baseUserSales/exportSalesList",
          this.listQuery
      );
      hideLoading();
      await saveBlob("导出业务员.xls", res.data);
    },
    async getList() {
      this.loading = true;
      console.log(this.listQuery, '2222');
      let res = await $api.baseUserSales.request(
        "querySalesList",
        this.listQuery
      );
      if (res.status == 1) {
        this.salesmanData = res.data.rows;
        this.totalResult = res.data.total;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
        this.loading = false;
      }
    },
    selectChangeEvent({ checked, row }) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({ checked, records }) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    async changeClientManagerCommit() {
      if (this.records.length === 0) {
        this.$XModal.alert({
          message: "请选择至少一个业务员",
          status: "error"
        });
        return;
      }
      // /baseUserSales/batchUpdateClientManager
      let data = {};
      data.ids = [];
      this.records.forEach(item => {
        data.ids.push(item.salesManId);
      });
      data.clientManagerId = this.clientManagerFormData.clientManagerId;
      let res = await $api.baseUserSales.request(
        "batchUpdateClientManager",
        data
      );
      if (res.status == 1) {
        this.$XModal.alert({
          message: "更换成功",
          status: "success"
        });
        this.changeClientManagerModal = false;
        this.getList();
        this.records = []
      }
    },
    async clientManagerReplaceCommit() {
      if (
        !this.clientManagerReplaceFormData.oldId ||
        !this.clientManagerReplaceFormData.newId
      ) {
        this.$XModal.alert({
          message: "请先选择原客户经理或者需要替换的客户经理",
          status: "error"
        });
        return;
      }
      let res = await $api.baseUserSales.request("updateSalesByClientManager", {
        newId: this.clientManagerReplaceFormData.newId,
        oldId: this.clientManagerReplaceFormData.oldId
      });
      if (res.status == 1) {
        this.$XModal.alert({
          message: "替换成功",
          status: "success"
        });
        this.clientManagerReplaceModal = false;
        this.getList();
      }
    },
    async querysalesManage() {
      var self = this;
      self.salesManageList = [];
      var data = {
        type: 2
      };
      let response = await $api.baseUserSales.request(
        "querySalesSelectQuick",
        data
      );
      if (response.status == 1) {
        let res = response.data;
        res.forEach(function(item, index) {
          var obj = {};
          obj.value = item.id;
          obj.label = item.text;
          self.salesManageList.push(obj);
        });
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error"
        });
      }
    },
    changeClientManager() {
      this.changeClientManagerModal = true;
      this.clientManagerFormData.clientManagerId = null;
      this.querysalesManage();
    },
    clientManagerReplace() {
      this.clientManagerReplaceModal = true;
      this.clientManagerReplaceFormData.newId = null;
      this.clientManagerReplaceFormData.oldId = null;
      this.querysalesManage();
    },
    createSalesman() {
      this.$refs.createSalesman.createSalesman();
    },
    editSalesman(row) {
      this.$refs.createSalesman.editSalesman(row);
    },
    seeSalesman(row) {
      this.$refs.salesmanDetail.getSalesmanDetail(row.salesManId);
    },
    search() {
      this.listQuery.page = 1;
      this.listQuery.rows = 10;
      // this.listQuery.orderBy = 2,
      // this.listQuery.isDesc = 1
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.currentPage;
      this.listQuery.rows = val.pageSize;
      this.getList();
    },
    delSalesman(row) {
      this.$XModal.confirm("您确定要删除吗？").then(type => {
        if (type === "confirm") {
          this.deleteCommit(row);
        }
      });
    },
    createCommit(val) {
      this.getList();
    },
    async deleteCommit(row) {
      var del = {
        id: row.salesManId
      };
      let res = await $api.baseUserSales.request("removeSales", del);
      if (res.status == 1) {
        this.getList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    }
  }
};
</script>
<style>
</style>